<h2 mat-dialog-title>Insurance Coverage</h2>
<form [formGroup]="coverageForm">
  <div class="dialog-content" mat-dialog-content>
    <div formArrayName="payorsGroup">
      <div
        *ngFor="let payor of payorsGroup.controls; let i = index"
        [formGroupName]="i"
        class="payor-card"
        [class.hidden]="i !== currentPayorIndex"
      >
        <div class="payor-header">
          <mat-checkbox formControlName="enableCheckbox" (change)="check(i)"> Enter manually </mat-checkbox>
          <button mat-icon-button color="warn" (click)="deletePayor(i)" [disabled]="payorsGroup.length === 1">
            <mat-icon>delete</mat-icon>
          </button>
        </div>

        <div class="payor-fields" *ngIf="payor.get('enableCheckbox').value">
          <mat-form-field>
            <mat-label>Payor</mat-label>
            <input matInput formControlName="payor" placeholder="Payor name" />
          </mat-form-field>

          <mat-form-field>
            <mat-label>Member Id</mat-label>
            <input matInput formControlName="member_id" placeholder="Member Id" />
          </mat-form-field>

          <mat-form-field>
            <mat-label>Payor Type</mat-label>
            <mat-select formControlName="payorType">
              <mat-option value="Primary">Primary</mat-option>
              <mat-option value="Secondary">Secondary</mat-option>
              <mat-option value="Tertiary">Tertiary</mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field>
            <mat-label>Group ID</mat-label>
            <input matInput formControlName="groupId" placeholder="Group ID" />
          </mat-form-field>
        </div>

        <div class="payor-fields" *ngIf="!payor.get('enableCheckbox').value">
          <mat-form-field>
            <mat-label>Search Payors</mat-label>
            <input type="text" matInput formControlName="payor" [matAutocomplete]="auto" />
            <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn">
              <mat-option *ngFor="let option of payors$ | async" [value]="option" [matTooltip]="option?.payor_name">
                {{ option?.payor_name }}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>

          <mat-form-field>
            <mat-label>Select Payor Id</mat-label>
            <mat-select formControlName="member_id">
              <mat-option *ngFor="let id of payor.get('payorIds').value" [value]="id">
                {{ id }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field>
            <mat-label>Payor Type</mat-label>
            <mat-select formControlName="payorType">
              <mat-option value="Primary">Primary</mat-option>
              <mat-option value="Secondary">Secondary</mat-option>
              <mat-option value="Tertiary">Tertiary</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    </div>

    <div class="payor-controls">
      <button mat-button color="accent" (click)="addPayor()" [disabled]="coverageForm.invalid">
        <mat-icon>add_circle_outline</mat-icon>
        Add payor
      </button>
      <div class="payor-pagination" *ngIf="payorsGroup.length > 1">
        <button mat-icon-button (click)="prevPayor()" [disabled]="currentPayorIndex === 0">
          <mat-icon>chevron_left</mat-icon>
        </button>
        <span class="payor-page-info">{{ currentPayorIndex + 1 }} / {{ payorsGroup.length }}</span>
        <button mat-icon-button (click)="nextPayor()" [disabled]="currentPayorIndex === payorsGroup.length - 1">
          <mat-icon>chevron_right</mat-icon>
        </button>
      </div>
    </div>
  </div>

  <div mat-dialog-actions fxLayout="row" fxLayoutAlign="flex-end center">
    <button mat-button type="button" (click)="onNoClick()">Close</button>
    <button mat-raised-button color="primary" [disabled]="coverageForm.invalid" (click)="onSaveCoverage()">Save</button>
  </div>
</form>
